/**
 * Hash PII (Personally Identifiable Information) for ad network matching
 *
 * Follows industry standard (Meta, TikTok, Reddit):
 * - Normalize to E.164 format (+12125551234)
 * - SHA-256 hash
 * - Lowercase hex encoding
 */

/**
 * Hash a phone number for ad network matching
 *
 * @param phoneNumber - Phone number in E.164 format (+12125551234)
 * @returns SHA-256 hash as lowercase hex string
 */
export const hashPhoneNumber = async (phoneNumber: string): Promise<string> => {
  // Normalize: remove all non-digits
  const digits = phoneNumber.replace(/\D/g, "")

  // Ensure E.164 format with + prefix
  const normalized = `+${digits}`

  // Hash using SHA-256
  const msgBuffer = new TextEncoder().encode(normalized)
  const hashBuffer = await crypto.subtle.digest("SHA-256", msgBuffer)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, "0")).join("")

  return hashHex.toLowerCase()
}
